module.exports = __webpack_public_path__ + "img/ProductBanner.d79ab35a.jpg";